module.exports = __webpack_public_path__ + "img/button_reg.c9a24b7c.svg";